import { styled } from "styled-components";

const StaticMetricText = styled.div`
    font-weight: 600;
    font-size: 18px;
    text-transform: uppercase;
    text-align: left;
    width: 100%;
    @media screen and (max-width: ${(props) => props.theme.breakpoint}px) {
        text-align: center;
    }
`;
const StaticMetricValue = styled.div`
    font-weight: 600;
    font-size: 25px;
    text-align: left;
    color: ${(props) => props.theme.gradient.gradientEnd};
    width: 100%;
    @media screen and (max-width: ${(props) => props.theme.breakpoint}px) {
        text-align: center;
    }
`;
const StaticMetricContainer = styled.div`
    padding: 1%;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

interface StaticMetricItemProps {
    text: string;
    value: number;
}

export const StaticMetricItem: React.FC<StaticMetricItemProps> = (props) => {
    return (
        <StaticMetricContainer>
            <StaticMetricValue>
                {Number(props.value).toLocaleString()}
            </StaticMetricValue>
            <StaticMetricText>{props.text}</StaticMetricText>
        </StaticMetricContainer>
    );
};
